import { render } from "./HomeView.vue?vue&type=template&id=a2ede066&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=a2ede066&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/personal-website/personal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ede066"]])

export default __exports__